import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerStmtService } from '../owner-stmt.service';
import { OwnerStmt } from '../owner-stmt';
import { OwnerStmtComponent } from '../owner-stmt/owner-stmt.component';
import { TaxPreviewDialogComponent } from '../nacha/tax-preview-dialog/tax-preview-dialog.component';

@Component({
    selector: 'app-owner-stmt-list',
    templateUrl: './owner-stmt-list.component.html',
    styleUrls: ['./owner-stmt-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerStmtListComponent implements OnInit {
	constructor(
		private ownerStmtService: OwnerStmtService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ownerStmtService.statuses
	}



	// data
	ownerStmts: any;
	ownerStmt: OwnerStmt;
	selectedStmts: OwnerStmt[] = [];

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'shortTermRentalId', header: 'Str Id', width: 'auto' },
		{ field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'ownerName', header: 'Owner Name', width: 'auto' },
		{ field: 'ownerAdrState', header: 'Owner Address State', width: 'auto' },
		{ field: 'ownerAdrCity', header: 'Owner Address City', width: 'auto' },
		{ field: 'propertyAdrState', header: 'Property Address State', width: 'auto' },
		{ field: 'propertyAdrCity', header: 'Property Address City', width: 'auto' },
	];

	ngOnInit(): void 
	{

		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.ownerStmtId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerStmt-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerStmtService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerStmts = res.data.ownerStmts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerStmts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(ownerStmt: OwnerStmt) {
		try {
			this.formLoading = true;
			this.ownerStmtService.update(ownerStmt)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.ownerStmts.map((ownerStmt, i) => {
							if (ownerStmt.ownerStmtId === res.data.ownerStmt.ownerStmtId) {
								this.ownerStmts[i] = res.data.ownerStmt;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(ownerStmt: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(ownerStmt));

			this.formLoading = true;
			this.ownerStmtService.delete(ownerStmt.ownerStmtId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.ownerStmts.splice(this.ownerStmts.indexOf(ownerStmt), 1);
						this.recordTotal = this.ownerStmts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OwnerStmt ' + ownerStmt.ownerStmtId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OwnerStmt ' + ownerStmt.ownerStmtId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * Tax Preview / NACHA Generation
	 */
	openTaxPreview() {
		if (!this.selectedStmts || this.selectedStmts.length === 0) return;

		const dialogConfig = new MatDialogConfig();
		dialogConfig.maxWidth = '90vw';
		dialogConfig.width = '900px';
		dialogConfig.disableClose = false;
		dialogConfig.data = {
			ownerStmtIds: this.selectedStmts.map((s: any) => s.ownerStmtId)
		};
		this.dialog.open(TaxPreviewDialogComponent, dialogConfig);
	}


	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// for define width of dilog
		dialogConfig.maxWidth= "60vw";

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OwnerStmt',
			
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOwnerStmtCB(data);

				// close the dialogBox
			//	dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(ownerStmt: OwnerStmt) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerStmt: ownerStmt,
			title: 'Edit OwnerStmt'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerStmtComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOwnerStmtCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOwnerStmtCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOwnerStmtCB(ownerStmt: OwnerStmt) {
		console.log('Adding OwnerStmt: ' + JSON.stringify(ownerStmt));
		// if we don't have a ownerStmts array yet...
		if (!this.ownerStmts) {
			this.ownerStmts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.ownerStmts.unshift(ownerStmt);

		// no idea what this is but it is required to update the array
		this.ownerStmts = [...this.ownerStmts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmt ' + ownerStmt.ownerStmtId + ' Added', life: 3000 });
	}

	updateOwnerStmtCB(ownerStmt: OwnerStmt) {
		console.log('Updating OwnerStmt: ' + JSON.stringify(ownerStmt));
		let itemIndex = this.ownerStmts.findIndex((item: any) => item.ownerStmtId === ownerStmt.ownerStmtId);
		this.ownerStmts[itemIndex] = ownerStmt;

		// no idea what this is but it is required to update the array
		this.ownerStmts = [...this.ownerStmts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmt ' + ownerStmt.ownerStmtId + ' Updated', life: 3000 });
	}

	deleteOwnerStmtCB(ownerStmt: OwnerStmt) {
		console.log('Removing OwnerStmt: ' + ownerStmt);
		this.ownerStmts.splice(this.ownerStmts.indexOf(ownerStmt), 1);
		this.recordTotal = this.ownerStmts.length;

		// no idea what this is but it is required to update the array
		this.ownerStmts = [...this.ownerStmts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerStmt ' + ownerStmt.ownerStmtId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.ownerStmts ? this.first === (this.ownerStmts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.ownerStmts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerStmt: any) {
		if (ownerStmt?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerStmt.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
